import { render, staticRenderFns } from "./PhotoManager.vue?vue&type=template&id=275ddf72"
import script from "./PhotoManager.vue?vue&type=script&lang=js"
export * from "./PhotoManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports